import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import isEqual from 'lodash.isequal';
import React, { useEffect, useState } from 'react';
import { TimePointType } from '../../../api/timeranges/types';
import {
  useGlobalLocaleContext,
  useTimePointSelectorContext,
} from '../../../context/contexts';
import { ColoredPaper, StyledSlider } from './component-utils';
import { dateFormatter, displayDate } from './utils-display';
export const TimePointPicker = () => {
  const timePointSelectorHandle = useTimePointSelectorContext();
  const localeHandle = useGlobalLocaleContext();
  const locale = localeHandle.selected;
  const [state, dispatch] = timePointSelectorHandle;
  const getIndexForDate = (date: TimePointType) => {
    const index = state.range.all.findIndex((v) => isEqual(v, date));
    if (index === -1) {
      throw new Error(
        `Invalid State - Date ${date} not found in state.range.all - ${state.range.all}`
      );
    }
    return index;
  };
  const [value, setValue] = useState<number>(getIndexForDate(state.date));

  useEffect(() => {
    setValue(getIndexForDate(state.date));
  }, [state.range, state.date]);

  const handleLeftClick = () => {
    if (value > 0) {
      const newValue = value - 1;
      setValue((value) => value - 1);
      const date = state.range.all.at(newValue);
      if (date) {
        dispatch({ type: 'update-point', date });
      }
    }
  };

  const handleRightClick = () => {
    if (value < state.range.all.length - 1) {
      const newValue = value + 1;
      setValue((value) => value + 1);
      const date = state.range.all.at(newValue);
      if (date) {
        dispatch({ type: 'update-point', date });
      }
    }
  };
  return (
    <Grid
      item
      style={{
        margin: 'auto 10px',
        height: '8vh',
        width: '20vw',
      }}
    >
      <ColoredPaper style={{ height: '100%' }}>
        <Grid container justifyContent="center">
          <Grid
            item
            style={{
              flexGrow: 1,
              margin: '1vh 3vw 0 3vw',
              height: '3vh',
            }}
          >
            <Typography
              variant="subtitle1"
              color="secondary"
              style={{
                textAlign: 'center',
              }}
            >
              {displayDate(state.date, state.selectedGranularity, locale)}
            </Typography>
          </Grid>
          <Grid
            item
            container
            xs={12}
            spacing={0}
            alignItems="center"
            marginTop={-1}
          >
            <Box sx={{ flex: '0 0 auto' }}>
              <IconButton
                onClick={handleLeftClick}
                disabled={value === 0}
                aria-label="move selected left"
                color="secondary"
              >
                <KeyboardArrowLeft />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flex: '1 1 auto',
                alignItems: 'center',
                padding: '0px 4px',
              }}
            >
              <StyledSlider
                getAriaLabel={() => 'TimeSlider point picker'}
                value={value}
                onChange={(e: any, v: number | number[]) => {
                  const arr = v as number;
                  setValue(arr);
                }}
                onChangeCommitted={(e: any, v: number | number[]) => {
                  const dateIndex = v as number;
                  const date = state.range.all.at(dateIndex);
                  if (date) {
                    dispatch({ type: 'update-point', date });
                  } else {
                    throw new Error(
                      `index ${dateIndex} is out of range for state.range.all - ${state.range.all}`
                    );
                  }
                }}
                valueLabelDisplay="auto"
                min={0}
                max={state.range.all.length - 1}
                getAriaValueText={(value: number) => {
                  const v = state.range.all.at(value);
                  return v
                    ? dateFormatter(v, state.selectedGranularity, locale)
                    : '';
                }}
                valueLabelFormat={(value: number) => {
                  const v = state.range.all.at(value);
                  return v
                    ? dateFormatter(v, state.selectedGranularity, locale)
                    : '';
                }}
                track={false}
              />
            </Box>
            <Box sx={{ flex: '0 0 auto' }}>
              <IconButton
                onClick={handleRightClick}
                disabled={value === state.range.all.length - 1}
                aria-label="move selected right"
                color="secondary"
              >
                <KeyboardArrowRight />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </ColoredPaper>
    </Grid>
  );
};
